import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

export const macDeviceIcon = html`
  <svg
    id="mac"
    width="28"
    height="24"
    viewBox="0 0 28 24"
    style=${styleMap({ fill: 'var(--icon-color-default)', padding: 'var(--os-icon-padding, 10px)' })}
  >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4h20v13H2V4Zm2 2h16v9H4V6Z" />
    <path d="M11 18v2H7v2h10v-2h-4v-2h-2Z" />
    <circle cx="21" cy="17" r="7" style=${styleMap({ fill: 'var(--icon-color-inverted)' })} />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.3 13.433c.286-.334.767-.584 1.166-.6.05.464-.135.93-.412 1.264-.276.335-.73.595-1.174.56-.06-.454.164-.928.42-1.224Zm2.812 5.212v-.004c-.049-.02-1.05-.426-1.062-1.602-.008-.98.785-1.463.853-1.504l.003-.002c-.465-.681-1.19-.775-1.448-.785-.377-.039-.743.106-1.042.224-.19.074-.352.139-.474.139-.135 0-.302-.067-.49-.141-.246-.098-.526-.209-.816-.204-.672.01-1.292.391-1.638.993-.698 1.211-.178 3.006.501 3.988.333.481.73 1.022 1.25 1.002.233-.009.4-.08.57-.152.198-.084.403-.172.727-.172.31 0 .506.085.695.167.18.078.353.152.612.148.54-.01.882-.49 1.212-.973.37-.54.529-1.063.546-1.122Z"
    />
  </svg>
`;

export const winDeviceIcon = html`
  <svg
    id="win"
    width="28"
    height="24"
    viewBox="0 0 28 24"
    style=${styleMap({ fill: 'var(--icon-color-default)', padding: 'var(--os-icon-padding, 10px)' })}
  >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4h20v13H2V4Zm2 2h16v9H4V6Z" />
    <path d="M11 18v2H7v2h10v-2h-4v-2h-2Z" />
    <circle cx="21" cy="17" r="7" style=${styleMap({ fill: 'var(--icon-color-inverted)' })} />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.167 16.81v-3.977l-4.543.627v3.35h4.543Zm-4.919 0v-3.3l-3.415.471v2.83h3.416Zm0 3.68v-3.26h-3.415v2.789l3.416.47Zm4.919.677V17.23h-4.543v3.309l4.543.627Z"
    />
  </svg>
`;

export const androidDeviceIcon = html`
  <svg
    width="28"
    height="24"
    style=${styleMap({ fill: 'var(--icon-color-default)', padding: 'var(--os-icon-padding, 10px)' })}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4Zm2 1a1 1 0 0 1 1-1l1 1h4l1-1a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V5Z"
    />
    <circle cx="21" cy="17" r="7" fill="#F7F7F7" />
    <path
      d="M22.918 17.924a.343.343 0 0 1-.347-.339c0-.186.155-.338.347-.338.191 0 .347.152.347.338a.343.343 0 0 1-.347.34Zm-3.836 0a.343.343 0 0 1-.347-.339c0-.186.156-.338.347-.338.191 0 .347.152.347.338a.343.343 0 0 1-.347.34Zm3.96-2.04.694-1.173a.14.14 0 0 0-.053-.192.146.146 0 0 0-.197.051l-.703 1.188A4.368 4.368 0 0 0 21 15.385c-.644 0-1.247.133-1.784.373l-.702-1.188a.146.146 0 0 0-.197-.051.14.14 0 0 0-.053.192l.694 1.173a3.993 3.993 0 0 0-2.125 3.2h8.334a3.994 3.994 0 0 0-2.125-3.2Z"
    />
  </svg>
`;

export const iosDeviceIcon = html`
  <svg
    width="28"
    height="24"
    style=${styleMap({ fill: 'var(--icon-color-default)', padding: 'var(--os-icon-padding, 10px)' })}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4Zm2 1a1 1 0 0 1 1-1l1 1h4l1-1a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V5Z"
      fill="#000"
    />
    <circle cx="21" cy="17" r="7" fill="#F7F7F7" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.3 13.433c.285-.334.767-.584 1.166-.6.05.464-.135.93-.412 1.264-.276.335-.73.595-1.174.56-.06-.453.164-.928.42-1.224Zm2.812 5.212v-.004c-.049-.02-1.05-.426-1.062-1.602-.008-.98.784-1.463.853-1.504l.003-.002c-.465-.681-1.19-.775-1.448-.785-.377-.039-.743.106-1.042.224-.19.074-.352.139-.474.139-.135 0-.302-.067-.49-.141-.246-.098-.526-.209-.816-.203-.672.01-1.292.39-1.638.992-.698 1.211-.178 3.006.502 3.988.332.481.729 1.022 1.25 1.003.233-.01.398-.08.57-.153.197-.084.402-.172.727-.172.31 0 .506.085.694.167.18.078.353.152.612.148.54-.01.882-.49 1.212-.973a4.34 4.34 0 0 0 .547-1.122Z"
      fill="#000"
    />
  </svg>
`;
